// extracted by mini-css-extract-plugin
module.exports = {"content":"StepContentSection_content__aBhob","back":"StepContentSection_back__PIMTO","title":"StepContentSection_title__4I6sF","text":"StepContentSection_text__0kSsg"};